import {DragEndEvent} from "@dnd-kit/core";
import cloneDeep from "lodash/cloneDeep";

import {MetricOrder} from "@/lib/queries/statuspages.ts";
import {Metric} from "@/lib/types/statuspages.ts";

interface HandleDragEndParams {
  metrics: Metric[];
  statusPageId: number;
  updateOrder: (variables: {
    variables: {
      statusPageID: number;
      data: MetricOrder[];
    };
  }) => Promise<unknown>;
  setMetrics: (metrics: Metric[]) => void;
}

export const createHandleDragEnd = ({metrics, statusPageId, updateOrder, setMetrics}: HandleDragEndParams) => {
  return async (event: DragEndEvent) => {
    const source = event.active.data.current?.original as Metric | undefined;
    const target = event.over?.data.current?.original as Metric | undefined;

    if (!source || !target) {
      return;
    }

    const newData = cloneDeep(metrics);

    const srcPos = metrics.findIndex((m) => m.id === source.id);
    const trgPos = metrics.findIndex((m) => m.id === target.id);
    const [movedRow] = newData.splice(srcPos, 1);
    newData.splice(trgPos, 0, movedRow);

    const payload = newData.map((item, index) => ({
      metricId: item.id,
      sortingWeight: index,
    }));

    setMetrics(newData);

    await updateOrder({
      variables: {
        statusPageID: statusPageId,
        data: payload,
      },
    });
  };
};
